export default "__VITE_ASSET__D6xVoaH4__"